import React from 'react';
import { motion } from 'framer-motion';
import TeamCalendar from '../../components/calendar/TeamCalendar';

const LineCalendar = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 pb-20 lg:pb-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">ปฏิทิน</h1>
        <p className="text-gray-600">จัดการตารางนัดหมายและกิจกรรมของคุณ</p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <TeamCalendar />
      </motion.div>
    </div>
  );
};

export default LineCalendar;
